const formatNumber = (num) => num || 0

export const handleDataTable = (data) => {
  const dataFormat = data.map((item) => ({
    name: item?.scoreRangeId,
    value: item?.numberCompanies,
    percent: item?.totalPercent * 10 ** 2,
    scoreRangeId: item?.scoreRangeId,
  }))

  const totalCompanies = data.reduce(
    (a, b) => a + formatNumber(b?.numberCompanies),
    0,
  )

  return dataFormat?.length
    ? [
        ...dataFormat,
        {
          name: 'portfolioScore.total',
          value: totalCompanies,
          percent: 100,
          isTotal: true,
        },
      ]
    : []
}
